@if ((incomeTaxEntity$ | async)?.aangifte; as aangifte) {
  <form [formGroup]="formGroup">
    @if (pgaRestantPgaVoorgaandeJaren.length > 0) {
      <div formArrayName="pgaRestantPgaVoorgaandeJaren">
        @for (item of pgaRestantPgaVoorgaandeJaren.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                            class="custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
                                            placeholder="Restant PGA voorgaande jaren"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [required]=true
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Restant voorgaande jaren
  </snelstart-ui-button>
}
